// Material Dashboard 2 PRO React TS Base Styles
import typography from "assets/theme/base/typography";
import borders from "assets/theme/base/borders";

// Material Dashboard 2 PRO React TS Helper Functions
import pxToRem from "assets/theme/functions/pxToRem";

const { size, fontWeightMedium } = typography;
const { borderRadius } = borders;

// types
type Types = any;

// Flat status banners (Figma "Banner - amber/green"); filled/outlined variants keep MUI defaults.
const alert: Types = {
  styleOverrides: {
    root: {
      borderRadius: borderRadius.md,
      fontSize: size.sm,
      fontWeight: fontWeightMedium,
      padding: `${pxToRem(8)} ${pxToRem(16)}`,
    },
    message: {
      padding: 0,
    },
    standardWarning: {
      backgroundColor: "#FFF4E0",
      color: "#8A4B00",
    },
    standardSuccess: {
      backgroundColor: "#E6F6EA",
      color: "#1E6B35",
    },
  },
};

export default alert;
